<template>
<div class="error-container">
  <p class="warning">{{  errorMessage }}</p>
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    errorMessage: ''
  }
}
</script>